import { Fragment, useState } from 'react'
import { Button, Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import { fillMonths } from './helpers'
import type { MonthlyEngineStats, MonthStats, TypeStats } from './types'
moment.locale('ja')

const typeCounts = (monthStats: MonthStats, type: TypeStats['type']) =>
  monthStats.byType.find((typeStats) => typeStats.type === type) ?? { totalAll: 0, totalSuccess: 0 }

export const MonthlyEngineStatsTable = ({ stats }: { stats: MonthlyEngineStats }) => {
  const [expandedMonths, setExpandedMonths] = useState<Set<string>>(new Set())
  const toggleMonth = (month: string) =>
    setExpandedMonths((current) => {
      const next = new Set(current)
      if (!next.delete(month)) {
        next.add(month)
      }
      return next
    })

  return (
    <Table bordered hover>
      <thead>
        <tr>
          <th rowSpan={2} />
          <th rowSpan={2}>年月</th>
          <th colSpan={2}>合計</th>
          <th colSpan={2}>紙面</th>
          <th colSpan={2}>小組</th>
        </tr>
        <tr>
          <th>実行回数</th>
          <th>成功回数</th>
          <th>実行回数</th>
          <th>成功回数</th>
          <th>実行回数</th>
          <th>成功回数</th>
        </tr>
      </thead>
      <tbody>
        {fillMonths(stats.from, stats.to, stats.months).map((monthStats) => {
          const { month, byGroup } = monthStats
          const expanded = expandedMonths.has(month)
          const page = typeCounts(monthStats, 'page')
          const subLayout = typeCounts(monthStats, 'sub_layout')
          return (
            <Fragment key={month}>
              <tr data-month={month}>
                <td>
                  {byGroup.length > 0 && (
                    <Button
                      variant='link'
                      size='sm'
                      className='p-0'
                      aria-label={expanded ? '内訳を閉じる' : '内訳を開く'}
                      aria-expanded={expanded}
                      onClick={() => toggleMonth(month)}
                    >
                      <FontAwesomeIcon icon={expanded ? 'caret-down' : 'caret-right'} />
                    </Button>
                  )}
                </td>
                <td>{moment(month).format('YYYY年M月')}</td>
                <td>{monthStats.totalAll}</td>
                <td>{monthStats.totalSuccess}</td>
                <td>{page.totalAll}</td>
                <td>{page.totalSuccess}</td>
                <td>{subLayout.totalAll}</td>
                <td>{subLayout.totalSuccess}</td>
              </tr>
              {expanded &&
                byGroup.map((groupStats) => (
                  <tr key={`${month}_${groupStats.groupId}`} className='table-light' data-group-of={month}>
                    <td />
                    <td className='ps-4'>{groupStats.name}</td>
                    <td>{groupStats.totalAll}</td>
                    <td>{groupStats.totalSuccess}</td>
                    {/* the API has no per-group type breakdown */}
                    <td />
                    <td />
                    <td />
                    <td />
                  </tr>
                ))}
            </Fragment>
          )
        })}
      </tbody>
    </Table>
  )
}
